import { TradeSubCategoryType, TradeSubCategoryActionsList } from "../actions/tradeSubCategoryActions";
import { Action } from "../actions/types";

const initialValue: Array<TradeSubCategoryType> = []

export const TradeSubCategoryReducer = (state: TradeSubCategoryType[] =initialValue , action: Action) => {

    switch (action.type) {

        case TradeSubCategoryActionsList.ADD_TRADESUBCATEGORY: {

            return [...state, action.data]
        }

        case TradeSubCategoryActionsList.EDIT_TRADESUBCATEGORY: {

            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated
        }

        case TradeSubCategoryActionsList.FETCH_TRADESUBCATEGORY: {

            return action.data

        }

        case TradeSubCategoryActionsList.DELETE_TRADESUBCATEGORY: {
            return state.filter(i => i.id !== action.data.id)

        }
        case TradeSubCategoryActionsList.CLEAR_TRADESUBCATEGORY: {
            return initialValue

        }

        default: return state
    }

}